import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationHeader = ({ dealershipName }) => {
  return (
    <div className="bg-card border-b border-border py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Zap" size={28} color="var(--color-primary)" strokeWidth={2.5} />
            </div>
            <div>
              <h1 className="text-2xl font-heading font-semibold text-foreground">
                Gutschein-Verifizierung
              </h1>
              <p className="text-sm text-muted-foreground mt-1">
                {dealershipName || 'Grid Balance Partner Portal'}
              </p>
            </div>
          </div>
          <div className="hidden sm:flex items-center gap-2 px-4 py-2 bg-success/10 rounded-lg">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
            <span className="text-sm font-medium text-success">Aktive Session</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationHeader;